export const TypePaper = {
    BHYT: "Bảo hiểm y tế",
    DKYXE: "Đăng ký xe",
    GPLX: "Giấy phép lái xe",
    NPT: "Người phụ thuộc",
    BHXH: "Bảo hiểm xã hội",
};
